<template>
  <el-popover :placement="placement" width="400" @show="openPopover" @touchmove.prevent
    popper-options="{ preventOverflow: true, overflowPadding: 10 }" :teleported="false">
    <Cart :pageLoading="pageLoading" />
    <template #reference>
      <div class="tool-item" :class="{ active: isHeader }" @click="goToCart">
        <span class="iconfont icon-cart"></span>
        <!-- <el-badge :value="productNum" class="badge-item" :offset="[0, 1]"> -->
        <!-- <img src="@/assets/images/icons/cart.svg" :style="{ width: `${iconSize}px`, height: `${iconSize}px` }" /> -->
        <!-- </el-badge> -->
        <div v-if="productNum" class="product-num">{{ productNum }}</div>
      </div>
    </template>
  </el-popover>
</template>

<script setup>
import { useCartStore, useUserStore } from '@/stores'
import { ElMessage } from 'element-plus'
import { computed, defineProps, reactive } from 'vue'
import { useRouter } from 'vue-router'
import Cart from '../SideBar/CartList'

defineProps({
  placement: {
    type: String,
    default: 'left',
  },
  iconSize: {
    type: Number,
    default: 24,
  },
  isHeader: {
    type: Boolean,
    default: false,
  },
})

const cartStore = useCartStore()
const userStore = useUserStore()
const $router = useRouter()
const productNum = computed(() => {
  return userStore.isLogin ? cartStore.productNum : 0
})
const state = reactive({
  loading: false,
  noGetData: false,
})

const goToCart = () => {
  if (!userStore.isLogin) {
    $router.push({ name: 'login' })
    return
  }
  $router.push({ name: 'cart' })
}
const pageLoading = () => {
  state.loading = true
  return () => {
    state.loading = false
  }
}

const openPopover = async () => {
  if (!userStore.isLogin) return
  if (state.noGetData) return
  try {
    state.noGetData = true
    state.loading = true
    await cartStore.updateCart()
    cartStore.getCartProductNum()
  } catch (error) {
    ElMessage({ type: 'error', message: error })
  } finally {
    state.loading = false
    setTimeout(() => {
      state.noGetData = false
    }, 10000)
  }
}

userStore.isLogin && cartStore.getCartProductNum()
</script>

<style lang="scss" scoped>
.tool-item {
  height: 58px;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
}

.active {
  width: 40px;
  height: 40px;
  border-radius: 838px;
  box-sizing: content-box;

  &:hover {
    background-color: var(--line-light-gray-color);
  }

  &.tool-item {
    height: 40px;
    margin-right: -4px;

    .icon-cart {
      font-size: 24px;
      // color: var(--black-common-color-9);
    }

    .product-num {
      right: 0px;
      top: 0px;
    }
  }
}

.product-num {
  position: absolute;
  right: -10px;
  top: 8px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #f56c6c;
  text-align: center;
  color: var(--white-color-1-light);
  font-size: 10px;
  line-height: 16px;
}

.icon-cart {
  font-size: 24px;
  color: var(--black-color-9);
}
</style>
